import { Box, Typography, makeStyles, Paper, Link } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import CustomTitle from "../common/CustomTitle";
import EditAdditionalInfoModal from "./EditAdditionalInfoModal";
import {setContactDetails} from "../../../../actions/contactAction";
import EachCustomField from "./EachCustomField";
import {updateContactCustomFieldV2} from "../../../../api/contactApi";
import { formatDateWithoutZone } from "../../../globals/TimezoneConversion";
import Utils from "../../Helpers/Utils";
import { RenderFolderIcon } from "../../../common/RenderFolderIcon";

const useStyles = makeStyles({
  hoverDiv: {
    "&:hover": {
      "& $icon": {
        opacity: 1,
        transition: "width .35s",
        width: "42px",
      },
    },
  },
  icon: {
    opacity: 0,
    width: 0,
  },
});

const AdditionalInfo = (props) => {
  const [open, setOpen] = useState(false);
  const [contactCustomFields, setContactCustomFields] = useState([]);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
      if(props?.contact?.all_contact_custom_fields) {
          setContactCustomFields(props?.contact?.all_contact_custom_fields);
      }
  }, [props.contact]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (customFieldValues) => {
      updateContactCustomFieldV2({
          contactId: props.contact.id,
          params: Object.values(customFieldValues),
      }).then((response) => {
          if (response.success) {
              setContactCustomFields(response.data);
              setOpen(false);
          } else if (!response.success && response.status === 403) {
              if (response.data && response.data.data) {
                  setErrors(response.data.data);
              }
          }
      });
  };


  const fieldsByGroup = () => {
    const groupedFields = {};
    const seenFieldIds = new Set();

    try {
      contactCustomFields?.forEach((field) => {
        // Skip duplicates by unique user_custom_field_id
        if (!field?.user_custom_field_id || seenFieldIds.has(field.user_custom_field_id) || !field?.value || field?.value === "" || field.user_custom_fields.privacy_level === 'PRIVATE' && field.user_custom_fields.user_id != Utils.getAccountData("userId") ) return;
        seenFieldIds.add(field.user_custom_field_id);

        // Try to get a clean group name, or fallback to empty string (no title)
        const groupName = (field.user_custom_fields?.user_custom_field_group_id && field.user_custom_fields?.group_name) ? field.user_custom_fields.group_name : '';

        if (!groupedFields[groupName]) {
          groupedFields[groupName] = [];
        }

        groupedFields[groupName].push(field);
      });
    } catch (err) {
      console.error("Error processing custom fields:", err);
      return null;
    }

    const sortedGroups = Object.entries(groupedFields).sort(([a], [b]) => {
      if (a === '') return 1;  // Move empty group (no group name) to bottom
      if (b === '') return -1;
      return 0;
    });

    return sortedGroups.map(([groupName, fields], index) => {
      if (fields.length === 0) return null;
      return (
        <div
          key={groupName || `no-group-${index}`}
          style={{
            border: "1px solid #c9c9c9",
            borderRadius: "4px",
            marginBottom: "8px",
          }}
        >
          {groupName !== "" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "4px 8px",
                backgroundColor: "rgba(60, 126, 243, 0.1)",
                borderBottom: "1px solid #c9c9c9",
              }}
            >
              {RenderFolderIcon(null, "var(--dark_blue)", 20)}
              <Typography variant="body1" style={{ color: "var(--dark_blue)", fontSize: "14px" }}>
                {groupName}
              </Typography>
            </div>
          )}

          <div style={{ padding: "4px 8px" }}>
            {fields.map((field, idx) => {
              const title = field?.user_custom_fields?.title || "Unnamed Field";
              const value = field?.value || "--";

              return (
                <div key={field.id || idx} style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: "6px" }}>
                  <Typography variant="subtitle2"  style={{ color: "var(--dark_blue)"}}><b>{title}:</b></Typography>

                  <Typography variant="subtitle2" color="textSecondary">{props.formType === 'date' ? formatDateWithoutZone(value, 'MM/DD/YYYY') : props.formType !== 'website' ? value : <Link to={{ pathname: `//${value.replace(/^https?:\/\//, '')}` }} target="_blank">{value}</Link>}</Typography>
                </div>
              );
            })}
          </div>
        </div>
      );
    });
  };

  const icons = useStyles();
  return (
    <Box className={icons.hoverDiv} sx={{ mt: 3 }}>
      <Box sx={{ gap: 10 }} mb={2}>
        <CustomTitle
          title={"CUSTOM FIELDS"}
          iconHide={icons.icon}
          handleOpen={handleOpen}
        />
      </Box>

      {contactCustomFields?.length > 0 && fieldsByGroup()}

      <EditAdditionalInfoModal
        open={open}
        errors={errors}
        setErrors={setErrors}
        contactCustomFields={contactCustomFields}
        onClose={handleClose}
        onSubmit={handleSubmit}
      />
    </Box>
  );
};

const mapStateToProps = (state) => {
    return {
        contact: state.addContactReducer.contact
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setContactDetails: (params) => dispatch(setContactDetails(params)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalInfo);
